import React from "react";
import {Button, Row, Col} from "react-bootstrap";
import Component from "../../components/AscComponent";
import CommonTable from "../Elements/Table/CommonTable";
import VocCategoryDeleteModal from "./VocCategoryDeleteModal";
import VocCategoryInsertModal from "./VocCategoryInsertModal";
import VocCategoryUpdateModal from "./VocCategoryUpdateModal";
import VocCategoryReadModal from "./VocCategoryReadModal";
import moment from 'moment';

export default class VocCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            pages: null,
            pageSize: 20,
            pageCount: 0,
            pageIndex: 0,
            loading: false,
            filtered: [],
            sorted: [{id: "created", desc: true}],

            // modal item
            show: false,
            modalType: null,
            selectedData: [],

            // form data
            voc_category_id: "",
            category_name: "",
            prompt_text: ""
        };
    }

    /**
     * 一覧表作成
     */
    getColumnsData() {
        return [
            {
                Header: this.props.langText.Body.VocCategoryName,
                accessor: "category_name",
                width: this.props.boardWidth ? this.props.boardWidth.medium : 200
            },
            {
                Header: this.props.langText.Body.VocCategoryPromptText,
                accessor: "prompt_text",
                width: this.props.boardWidth ? this.props.boardWidth.xlarge : 600,
                Cell: ({row}) => {
                    const text = row.original.prompt_text || '';
                    const maxLength = 80;
                    return text.length > maxLength
                        ? text.substring(0, maxLength) + '...'
                        : text;
                }
            },
            {
                Header: this.props.langText.Body.Created,
                accessor: "created",
                width: this.props.boardWidth ? this.props.boardWidth.medium : 150,
                disableFilters: true,
                Cell: ({row}) => {
                    return row.original.created
                        ? moment(row.original.created).format('YYYY/MM/DD')
                        : '';
                }
            }
        ];
    }

    /**
     * モーダル表示分岐
     */
    getModalBranch() {
        switch (this.state.modalType) {
            case "insert":
                return (
                    <VocCategoryInsertModal
                        onHide={() => this.setState({show: false})}
                        onClick={this.onClickHandle}
                        validationHandle={this.validationHandle}
                        state={this.state}
                        onTextChange={this.onTextChange}
                        langText={this.props.langText}
                        propSetState={this.propSetState}
                        charaLimit={this.props.charaLimit}
                        onTextChange_Limit={this.onTextChange_Limit}
                    />
                );
            case "update":
                return (
                    <VocCategoryUpdateModal
                        onHide={() => this.setState({show: false})}
                        onClick={this.onClickHandle}
                        validationHandle={this.validationHandle}
                        state={this.state}
                        onTextChange={this.onTextChange}
                        langText={this.props.langText}
                        propSetState={this.propSetState}
                        charaLimit={this.props.charaLimit}
                        onTextChange_Limit={this.onTextChange_Limit}
                    />
                );
            case "delete":
                return (
                    <VocCategoryDeleteModal
                        onHide={() => this.setState({show: false})}
                        onClick={this.onClickHandle}
                        validationHandle={this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        propSetState={this.propSetState}
                    />
                );
            case "read":
                return (
                    <VocCategoryReadModal
                        onHide={() => this.setState({show: false})}
                        onClick={this.onClickHandle}
                        validationHandle={this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        propSetState={this.propSetState}
                    />
                );
            default:
                return null;
        }
    }

    /**
     * モーダル表示
     */
    modalShow = (modalType) => (event) => {
        event.preventDefault();

        if (modalType === "update" || modalType === "read") {
            if (!Array.isArray(this.state.selectedData) || this.state.selectedData.length !== 1) {
                return this.showErrorObjectMessage('User_ModalSelectError');
            }
            const selected = this.state.selectedData[0];
            this.setState({
                show: true,
                modalType,
                voc_categories_uuid: selected.voc_categories_uuid,
                category_name: selected.category_name,
                prompt_text: selected.prompt_text
            });
        } else if (modalType === "delete") {
            if (!Array.isArray(this.state.selectedData) || this.state.selectedData.length === 0) {
                return this.showErrorObjectMessage('User_ModalSelectError');
            }
            this.setState({ show: true, modalType });
        } else {
            // insert
            this.setState({
                show: true,
                modalType,
                voc_categories_uuid: "",
                category_name: "",
                prompt_text: ""
            });
        }
    }

    /**
     * モーダル操作ハンドラ
     */
    onClickHandle = (modalType) => async () => {
        try {
            switch (modalType) {
                case "insert": {
                    const param = {
                        category_name: this.state.category_name,
                        prompt_text: this.state.prompt_text
                    };
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/insert`, param);
                    alert(this.props.langText.Message.VocCategoryInsertSuccess);
                    this.unblockUI();
                    this.setState({ show: false });
                    await this.reactTableRefresh();
                    break;
                }
                case "update": {
                    const param = {
                        voc_category_id: this.state.voc_categories_uuid,
                        voc_category_name: this.state.category_name,
                        voc_llm_prompt: this.state.prompt_text
                    };
                    this.blockUI();
                    try {
                        await this.ascAxios('post', `${this.reactContainerPath}/update`, param);
                        alert(this.props.langText.Message.VocCategoryUpdateSuccess);
                        this.setState({ show: false });
                        await this.reactTableRefresh();
                    } catch (updateErr) {
                        // 404エラーの場合は、データが削除されたことを通知
                        if (updateErr.response && updateErr.response.status === 404) {
                            alert(this.props.langText.Message.VocCategoryAlreadyDeleted);
                            this.setState({ show: false, selectedData: [] });
                            await this.reactTableRefresh();
                        } else {
                            // その他のエラーは更新失敗メッセージを表示
                            this.showErrorObjectMessage(this.props.langText.Message.VocCategoryUpdateError);
                            return;
                        }
                    } finally {
                        this.unblockUI();
                    }
                    break;
                }
                case "delete": {
                    const ids = this.state.selectedData.map(row => row.voc_categories_uuid);
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/delete`, { id: ids });
                    alert(this.props.langText.Message.VocCategoryDeleteSuccess);
                    this.unblockUI();
                    this.setState({ show: false, selectedData: [] });
                    await this.reactTableRefresh();
                    break;
                }
                default:
                    return this.showErrorObjectMessage('ModalTypeError');
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err);
        } finally {
            this.unblockUI();
        }
    }

    /**
     * バリデーション
     */
    validationHandle = (modalType) => {
        if (modalType === "insert" || modalType === "update") {
            return this.state.category_name && this.state.prompt_text;
        }
        if (modalType === "delete") {
            return Array.isArray(this.state.selectedData) && this.state.selectedData.length > 0;
        }
        return true;
    }

    render() {
        return (
            <div className="VocCategory">
                <Row>
                    <Col xs={12} md={12}>
                        <Button
                            id="voccategory-insert"
                            className="table-button"
                            variant="default"
                            size="sm"
                            onClick={this.modalShow("insert")}
                            hidden={!this.props.currentPermission.create}
                        >
                            {this.props.langText.Body.InsertTitle}
                        </Button>
                        <Button
                            id="voccategory-update"
                            className="table-button"
                            variant="default"
                            size="sm"
                            onClick={this.modalShow("update")}
                            hidden={!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.UpdateTitle}
                        </Button>
                        <Button
                            id="voccategory-read"
                            className="table-button"
                            variant="default"
                            size="sm"
                            onClick={this.modalShow("read")}
                            hidden={!!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.ReadTitle}
                        </Button>
                        <Button
                            id="voccategory-delete"
                            className="table-button"
                            variant="default"
                            size="sm"
                            onClick={this.modalShow("delete")}
                            hidden={!this.props.currentPermission.delete}
                        >
                            {this.props.langText.Body.DeleteTitle}
                        </Button>
                        <CommonTable
                            state={this.state}
                            tableHeight={this.props.tableHeight}
                            tbodyHeight={(this.props.tableHeight || 600) - 30}
                            propsPageIndex={this.state.pageIndex ? this.state.pageIndex : 0}
                            columns={this.state.columns}
                            data={this.state.data}
                            defaultPageSize={20}
                            loading={this.state.loading}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            sorted={this.state.sorted}
                            pageCount={this.state.pageCount}
                            manual={true}
                            showPagination={true}
                            showCheckbox={true}
                            showPageSize={true}
                            showFilter={true}
                            onClickRow={this.modalShow("read")}
                            onSelectedDataChange={(selectedData) => this.setState({ selectedData })}
                            langText={this.props.langText && this.props.langText.Table}
                        />
                    </Col>
                </Row>
                {this.getModalBranch()}
            </div>
        );
    }
}
